import { IComplateRequest } from '../../../interfaces'
import http from '../../HttpConfig'
import { APIS_ENDPOINTS } from '../../SERVICE-CONSTANTS'
import moment from 'jalali-moment';

const request_endpoints = APIS_ENDPOINTS.request

export const request_getAllByUser = async ({
  search,
  CurrentPage,
  PageSize,
  userId,
}: {
  search?: string
  CurrentPage: number
  PageSize: number
  userId: string
}) => {
  return http.get(
    request_endpoints.getallrequestbyuserid +
    `?CurrentPage=${CurrentPage}&PageSize=${PageSize}&UserId=${userId}${search ? `&search=${search}` : ''
    }${userId ? `&UserId=${userId}` : ''}`
  )
}

export const request_rejectrequest = async ({
  id,
  text,
  otherFilesInputRef,
}: {
  id: number
  text: string
  otherFilesInputRef: any[]
}) => {
  const formData = new FormData()
  formData.append('Id', id.toString())
  formData.append('Text', text)
  const files = otherFilesInputRef ?? []
  for (let i = 0; i < files.length; i++) {
    formData.append('IFile', files[i])
  }
  return http.post(request_endpoints.rejectrequest, formData)
}

export const request_getrequeststoppageperroleasync = async () => {
  return http.get(request_endpoints.getrequeststoppageperroleasync)
}
export const request_createcheck = async (data) => {
  return http.put(request_endpoints.createcheck, data)
}

export const request_getrequestcountbyadminrole = async () => {
  return http.get(request_endpoints.getrequestcountbyadminrole)
}

export const request_exportrequeststoppageperroleasync = async () => {
  return http.get(request_endpoints.exportrequeststoppageperroleasync)
}

export const request_exportrequestcountbyadminrole = async () => {
  return http.get(request_endpoints.exportrequestcountbyadminrole)
}
export const request_complete = async (id: number) => {
  return http.put(request_endpoints.completerequest, id)
}
export const request_setmeeting = async ({ id, date, time }: { id: number, date: string, time: string }) => {
  return http.put(request_endpoints.setmeetingrequest, { id, date, time })
}
export const request_setmeetingtime = async ({ id, date, time }: { id: number, date: string, time: string }) => {
  return http.put(request_endpoints.setmeetingtime, { id, date, time })
}


export const request_calculateGuarantee = async (
  {
    requestId,
    addToDataBase,
    amount,
    commissionRate,
    depositRate,
    vatRate,
    fileFee,
    minimumCommission,
    durationMonths,
  }:
    {
      requestId: number,
      addToDataBase: boolean,
      amount: number,
      commissionRate: number,
      depositRate: number,
      vatRate: number,
      fileFee: number,
      minimumCommission: number,
      durationMonths: number

    }) => {
  return http.put(request_endpoints.calculateGuarantee, {
    requestId,
    addToDataBase,
    amount,
    commissionRate,
    depositRate,
    vatRate,
    fileFee,
    minimumCommission,
    durationMonths
  })
}

export const request_calculateloan = async (
  {
    requestId,
    date,
    addToDataBase,
    loanAmount,
    interestRate,
    gracePeriodMonths,
    repaymentMonths,
    gracePeriodInterest,
  }:
    {
      requestId: number,
      date: string,
      addToDataBase: boolean,
      loanAmount: number,
      interestRate: number,
      gracePeriodMonths: number,
      repaymentMonths: number,
      gracePeriodInterest: number,
    }) => {
  return http.put(request_endpoints.calculateloan, {
    requestId,
    date,
    addToDataBase,
    loanAmount,
    interestRate,
    gracePeriodMonths,
    repaymentMonths,
    gracePeriodInterest,
  })
}



// export const request_imscompleterequest = async ({ data, id }: { data: IComplateRequest, id: number }) => {
//   const formData = new FormData();

//   // فیلدهای معمولی
//   formData.append("Id", id.toString() || "");
//   formData.append("Date", moment(data.contractConclusionDate).format("YYYY-MM-DDTHH:mm:ss.SSSSSSS") || "");
//   formData.append("Time", data.time || "");
//   formData.append("IsGratuitously", data.isGratuitously ? "true" : "false");
//   formData.append("ContractAmount", data.contractAmount?.toString() || "0");
//   formData.append("FacilityRate", data.facilityRate?.toString() || "0");
//   formData.append("FacilitiesBenefitAmount", data.facilitiesBenefitAmount?.toString() || "0");
//   formData.append("PlanName", data.planName || "");
//   formData.append("PlanProvince", data.planProvince?.toString() || "");
//   formData.append("PlanDomain", data.planDomain?.toString() || "");
//   formData.append("PartnershipStatus", data.partnershipStatus?.toString() || "");
//   formData.append("ServiceType", data.serviceType?.toString() || "");
//   formData.append("ServiceTypeDescription", data.serviceTypeDescription || "");
//   formData.append("FacilityContractType", data.facilityContractType?.toString() || "");
//   formData.append("FacilityContractTypeDescription", data.facilityContractTypeDescription || "");
//   formData.append("PaymentPeriod", data.paymentPeriod?.toString() || "");
//   formData.append("PaymentSteps", data.paymentSteps?.toString() || "");
//   formData.append("BreathingPeriod", data.breathingPeriod?.toString() || "");
//   formData.append("RepaymentPeriod", data.repaymentPeriod?.toString() || "");
//   formData.append("RepaymentSteps", data.repaymentSteps?.toString() || "");
//   formData.append("InstallmentsInterval", data.installmentsInterval?.toString() || "");
//   formData.append("LoanDepositAmount", data.loanDepositAmount?.toString() || "");
//   formData.append("HaveSecurity", data.haveSecurity ? "true" : "false");

//   // آرایه‌ها
//   data.resources?.forEach(r => formData.append("Resources", JSON.stringify(r)));
//   data.applicants?.forEach(a => formData.append("Applicants", JSON.stringify(a)));
//   data.contractSecurities?.forEach(c => formData.append("ContractSecurities", JSON.stringify(c)));
//   data.paymentspaies?.forEach(p => formData.append("paymentspaies", JSON.stringify(p)));
//   data.repaymentsPaybacks?.forEach(rp => formData.append("RepaymentsPaybacks", JSON.stringify(rp)));
//   data.deposits?.forEach(d => formData.append("Deposits", JSON.stringify(d)));

//   return http.put(request_endpoints.imscompleterequest, formData, {
//     headers: {
//       "Content-Type": "multipart/form-data",
//     },
//   });
// };

export const request_imscompleterequest = async ({ id }: { id: number }) => {


  return http.put(request_endpoints.imscompleterequest + '?RequestId=' + id);
};



export const request_UpsertCommitteeResolution = async (
  {
    requestId,
    isAccept,
    description,
    contractAmount,
    planName,
    paymentSteps,
    paymentPeriod,
    breathingPeriod,
    repaymentPeriod,
    pricePaymentPeriod,
  }:
    {
      requestId: number,
      isAccept: boolean,
      description: string,
      contractAmount: number,
      planName: string,
      paymentSteps: number,
      paymentPeriod: number,
      breathingPeriod: number,
      repaymentPeriod: number,
      pricePaymentPeriod: { id?: number, amountPaidToCompany: number }[],
    }) => {
  return http.put(request_endpoints.upsertcommitteeresolution, {
    requestId,
    isAccept,
    description,
    contractAmount,
    planName,
    paymentSteps,
    paymentPeriod,
    breathingPeriod,
    repaymentPeriod,
    pricePaymentPeriod,
  })
}